export default __webpack_public_path__ + "static/media/Chorus at the Climax.22b971f2.png";